import footerApi from 'Core/api/footerApi';
import {getNewInteractionId, PortalStaticContentParamType} from 'Core/ducks/footer';
import * as E from 'fp-ts/lib/Either';

const fetchLegalNoticeDetails = async () => {
  const contentMetadataId = window.location.hash.split('=')[1];
  const params: PortalStaticContentParamType = {
    interactionId: getNewInteractionId(),
    contentMetadataId: contentMetadataId,
  };

  const result = await footerApi.getPortalStaticContent({...params});
  return result;
};

export const getLegalNoticeData = () => {
  return fetchLegalNoticeDetails().then(data => {
    if (E.isRight(data)) {
      if (data.right) {
        if (data.right.contentMetaDataList !== undefined) {
          return data.right.contentMetaDataList[0];
        }
      }
    }
  });
};
